import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {message, Popover} from "antd";
import axios from "axios";
import AudioRecorder from "audio-recorder-polyfill";
import micIcon from "../../pages/icons/mic.svg";
import {BulbOutlined, LoadingOutlined, RedoOutlined} from "@ant-design/icons";
import {fetchWrapper} from "../../helpers";


const baseUrl = `${process.env.REACT_APP_API_URL}`;

const LeadingTextAreaWithMic = ({value, post, handleChangeAnswers, question, index, isBusyMic, setIsBusyMic}) => {
	window.MediaRecorder = AudioRecorder;
	const [isRecording, setIsRecording] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [AIAnswer, setAIAnswer] = useState('');
	const [myMessage, setMyMessage ] = useState(value);
	const [mediaRecorder, setMediaRecorder] = useState(null);
	const {t} = useTranslation();
	const textAreaRef = useRef(null);

	const startRecording = () => {
		navigator.mediaDevices
				.getUserMedia({ audio: true })
				.then((stream) => {
					setIsRecording(true);
					setIsBusyMic(true);
					const recorder = new MediaRecorder(stream);
					recorder.start();
					setMediaRecorder(recorder);
					recorder.addEventListener("dataavailable", (e) => {
						message.loading(t("functions.loading"));
						const audioBlob = new Blob([e.data], { type: "audio/wav" });
						const audioFile = new File([audioBlob], "recording.wav", {
							type: "audio/wav",
						});
						const formData = new FormData();
						formData.append("audio", audioFile);

						axios({
							method: "POST",
							url: `${process.env.REACT_APP_API_URL}/upload-audio`,
							headers: {
								"Content-Type": "multipart/form-data",
							},
							data: formData,
						})
								.then((data) => {
											if (myMessage.trim()){
												setMyMessage(prevState => `${prevState}\n${data.data}`);
											} else {
												setMyMessage(data.data);
											}
										}
								)
								.catch((error) => console.error(error))
								.finally(() => {
									setIsBusyMic(false);
								});
					});
				})
				.catch((error) => {
					message.error(t("functions.microphone"));
				});
	};

	const stopRecording = () => {
		setIsBusyMic(false);
		setIsRecording(false);
		mediaRecorder?.stop();
	};

	const toggleMic = () => {
		if (isRecording) {
			stopRecording();
			if (textAreaRef.current){
				textAreaRef.current.focus();
			}
		} else {
			startRecording();
		}
	};

	const getAIAnswer = async () => {
		setIsLoading(true);
		message.success(t("functions.generating"));
		fetchWrapper.post(`${baseUrl}/content-plan/leading-questions-answer`, {
			context: post,
			question: question,
		})
				.then((res)=>{
					if (res?.answer){
						setAIAnswer(res.answer);
						message.success(t("functions.successfullyGenerated"));
					}
				})
				.catch((err)=>{
					console.error(err);
					message.error(t("functions.wrong"));
				}).finally(()=>{
					setIsLoading(false);
		});
	};

	useEffect(() => {
		setMyMessage(prev => prev ? `${prev}\n\n${AIAnswer}` : AIAnswer);
	}, [AIAnswer]);

	useEffect(() => {
		handleChangeAnswers(myMessage, index)
		if (!myMessage.trim().length){
			setAIAnswer('');
		}
	}, [myMessage]);

	return (
			<div className='flex items-center gap-1'>
				<textarea
						ref={textAreaRef}
						value={myMessage}
						rows={3}
						className='w-full border resize-none text-sm p-2 rounded-md placeholder:text-xs'
						placeholder={`${t('assistant.yourAnswerFromQuestionLabel')} ${question}`}
						id={`qa-${index}`}
						onChange={e=> setMyMessage(e.target.value)}
				/>
				<div className='w-7 h-16 flex flex-col justify-center items-center gap-2'>
					<Popover
							placement='left'
							content={null}
							title={isRecording ? t("assistant.stopRecording") : t("assistant.startRecording")}
					>
						<button
							className={
							'text-white rounded-md p-3 w-full h-1/2 flex items-center justify-center text-md disabled:bg-violet-300 disabled:cursor-not-allowed'
							+ ` ${isRecording ? 'bg-red-500' : 'bg-violet-500'}`
							}
							disabled={(isBusyMic && !isRecording) || isLoading}
							onClick={toggleMic}
						>
							<img className={`min-w-5 min-h-5 w-5 h-5 ${isRecording ? 'animate-pulse' : ''}`} src={micIcon} alt="Микрофон"/>
						</button>
					</Popover>

					<Popover
							placement='left'
							content={null}
							title={isLoading ? t("assistant.waitAnswer") : AIAnswer ? t("assistant.reGetAnswer") : t("assistant.getAnswer")}
					>
						<button
								className={
										'text-white rounded-md p-3 w-full h-1/2 flex items-center justify-center text-md disabled:bg-fuchsia-300 disabled:cursor-not-allowed'
										+ ` ${isLoading ? 'bg-fuchsia-300' : 'bg-fuchsia-500'}`
								}
								disabled={(isBusyMic && !isRecording) || isLoading}
								onClick={getAIAnswer}
						>
							{isLoading ? (
									<LoadingOutlined />
							): AIAnswer ? (
									<RedoOutlined />
							) : (
									<BulbOutlined />
							)}
						</button>
					</Popover>
				</div>
			</div>
	);
};

export default LeadingTextAreaWithMic;